<template>
  <ul
    v-if="email || phones"
    class="customers-list-item"
  >
    <information-line
      v-if="email"
      :label="email"
      valueless
    />

    <information-line
      v-if="phones"
      :label="phones"
      valueless
      class="customers-list-phones"
    />
  </ul>
</template>

<script>
  import { PHONE_FORMAT } from '@cordel/helpers/form/validators/phone';
  import { CELLPHONE_FORMAT } from '@cordel/helpers/form/validators/cellphone';

  import patternize from '@sdk/helpers/formatters/patternize';
  // eslint-disable-next-line import/no-extraneous-dependencies
  import domains from '@/helpers/apis/domains';

  import InformationLine from '@cordel/components/Information/Line.vue';

  export default {
    name: 'CustomersListItem',
    components: {
      InformationLine,
    },
    props: {
      customer: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      phones() {
        const {
          CELULAR,
          PRINCIPAL,
        } = domains.phone_types;

        return (this.customer.phones || [])
          .filter(phone => phone.phone_type && [CELULAR, PRINCIPAL]
          .indexOf(phone.phone_type.name) > -1)
          .splice(0, 2)
          .map(phone => patternize(`${phone.code}${phone.number}`, {
            format: PHONE_FORMAT,
            bigFormat: CELLPHONE_FORMAT,
          }))
          .join(' ou ');
      },
      email() {
        const {
          emails,
        } = this.customer;

        if (emails && emails[0] && emails[0].address) {
          return emails[0].address.toLowerCase();
        }

        return null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .customers-list-item {
    margin-top: var(--cordel-spacing-xl);
  }

  .customers-list-phones {
    margin-top: var(--cordel-spacing-mini);
  }
</style>
